import crypto from '@smallwei/avue-data/utils/crypto'
import Vue from 'vue'
//const url = window.$website.url
const request = Vue.prototype.$axios;
const baseUrl = '/sys/api/next/datasource'
export const getList = (params) => {
  return request({
    url: baseUrl + '/get/page/by/condition',
    method: 'get',
    params: { cmd: params }
  })
}

export const getDetail = (id) => {
  return request({
    url: baseUrl + '/get/by/id',
    method: 'get',
    params: { id: id }
  })
}

export const remove = (ids) => {
  return request({
    url: baseUrl + '/remove',
    method: 'delete',
    params: [ids]
  })
}

export const add = (row) => {
  return request({
    url: baseUrl + '/do/create',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: baseUrl + '/do/update',
    method: 'put',
    data: row
  })
}
const queryURLParams = (URL) => {
  let url = URL.split("?")[1];
  const urlSearchParams = new URLSearchParams(url);
  const params = Object.fromEntries(urlSearchParams.entries());
  return params
}
export const dynamicSql = (data) => {
  const params = queryURLParams(window.location.href)
  return request({
    // url: baseUrl + '/dynamic-query',
    url: '/dtv/api/next/dashboard/do/dynamic/query',
    method: 'get',
    headers: {
      'Content-Type': 'application/json'
    },
    params: { cmd: data, ...params },
  })
}
export const dbTest = (data) => {
  return request({
    url: baseUrl + '/do/connection/test',
    method: 'post',
    headers: {
      'data': crypto.encrypt(JSON.stringify(data)),
      'Content-Type': 'application/json'
    },
    data: crypto.encrypt(JSON.stringify(data))
  })
}
